import axios from 'axios';
import to from 'await-to-js';

const getInitialState = () => {
  return {
    loading: false,
    anchorMargins: [],
  };
};

const store = {
  namespaced: true,

  state: {
    ...getInitialState(),
  },

  getters: {},

  mutations: {
    setAnchorMargins(state, anchorMargins) {
      state.anchorMargins = anchorMargins;
    },

    setLoading(state, isLoading) {
      state.loading = isLoading;
    },

    resetState(state) {
      Object.assign(state, getInitialState());
    },
  },

  actions: {
    async fetchAnchorMargins({ commit, rootState }, filters = {}) {
      const workpackageId = rootState.workpackages.selectedWorkpackage._id;
      if (!workpackageId) return;
      commit('setLoading', true);
      const params = {
        where: filters,
      };
      const [err, { data: anchorMargins }] = await to(
        axios.get(`/api/anchor-margins/workpackage/${workpackageId}`, { params })
      );
      if (err) {
        commit('setLoading', false);
        throw new Error(err.message);
      }
      commit('setAnchorMargins', anchorMargins);
      commit('setLoading', false);

      return anchorMargins;
    },

    async updateAnchorMargins(
      { commit, rootState },
      { updates = [], cascadeProportionately = false } = {}
    ) {
      const workpackageId = rootState.workpackages.selectedWorkpackage._id;
      if (!workpackageId) return;
      commit('setLoading', true);
      const [err] = await to(
        axios.patch(`/api/anchor-margins/workpackage/${workpackageId}`, {
          updates,
          cascadeProportionately,
        })
      );
      commit('setLoading', false);
      if (err) throw new Error(err.message);
    },

    resetState({ commit }) {
      commit('resetState');
    },
  },
};

export default store;
